/**
 * テキスト切り替え
 *
 * 使い方：
 * テキストを切り替えたいclassにjs-toggleTextを記述
 * data-turnOnTextにクリックされた際に切り替えるテキストを記述
 * data-turnOffTextにもう一度クリックされた際に切り替えるテキストを記述
 *
 * ex)
 * <h3 class="js-toggleText" data-turnOnText="開く" data-turnOffText="閉じる">開く</h3>
 */

const toggleText = (target, turnOnText, turnOffText) => {
    if (!target.text() || turnOnText === undefined || turnOffText === undefined) {
        return;
    }

    if (target.text() == turnOnText) {
        target.text(turnOffText);
    } else {
        target.text(turnOnText);
    }
};

$(() => {
    $(document).on('click', '.js-toggleText', (self) => {
        const target = $(self.currentTarget);
        const turnOnText = target.data('turnontext');
        const turnOffText = target.data('turnofftext');

        toggleText(target, turnOnText, turnOffText);

        self.stopPropagation();
    });
});
